import { t } from 'i18next'
import { Filter, FilterItem } from '@vtex/shoreline'
import { useSubpublisherCatalogFilter } from './useSubpublisherCatalogFilter'
import { DEFAULT_SELECTED_SUBPUBLISHER_CATALOG } from '~/modules/retailMedia/constants/subpublisherCatalogs'

import './styles.css'

export const SubpublisherCatalogFilter = (
  props: SubpublisherCatalogFilterProps
) => {
  const {
    filteredSubpublishers,
    handleSetValue,
    value,
    searchValue,
    setSearchValue
  } = useSubpublisherCatalogFilter(props)

  const { isLoading, campaignType } = props

  return (
    <Filter
      disabled={isLoading}
      label={t('rm:catalog')}
      value={value}
      setValue={handleSetValue}
      searchValue={searchValue}
      setSearchValue={setSearchValue}
      messages={{
        apply: t('rm:apply'),
        clear: t('rm:clear')
      }}
      style={{
        marginTop: 'var(--sl-space-2)',
        marginBottom: 'var(--sl-space-2)'
      }}
    >
      <>
        {campaignType !== 'off_site' && (
          <FilterItem value={DEFAULT_SELECTED_SUBPUBLISHER_CATALOG.label}>
            {DEFAULT_SELECTED_SUBPUBLISHER_CATALOG.label}
          </FilterItem>
        )}

        {filteredSubpublishers?.map(subpublisher => (
          <FilterItem
            key={subpublisher.id}
            value={subpublisher?.label as string}
          >
            {subpublisher?.label}
          </FilterItem>
        ))}
      </>
    </Filter>
  )
}
